

// Custom Element for Auto Scroll Target
class AutoScrollTarget extends HTMLElement {
    constructor() {
        super();
        this.scrollKey = this.getAttribute('scroll-key') || this.getAttribute('data-scroll-key');
        this.offset = parseInt(this.getAttribute('scroll-offset')) || 0;
        this.behavior = this.getAttribute('scroll-behavior') || 'smooth';
    }

    connectedCallback() {
        if (!this.scrollKey) {
            console.warn('AutoScrollTarget: scroll-key attribute is required');
            return;
        }

        // Listen for click events on anchor tags
        this.initScrollListener();
    }

    initScrollListener() {
        // Listen for clicks on the entire document
        document.addEventListener('click', (e) => {
            const target = e.target.closest('a[href]');
            if (!target) return;

            const href = target.getAttribute('href');
            if (!href) return;

            // Check if href contains the scroll key
            if (this.shouldScrollToElement(href)) {
                e.preventDefault();
                this.scrollToElement();
            }
        });
    }

    shouldScrollToElement(href) {
        // Remove leading # if present
        const cleanHref = href.replace('#', '');
        const cleanKey = this.scrollKey.replace('#', '');

        // Check various matching patterns
        return (
            cleanHref === cleanKey ||
            cleanHref.includes(cleanKey) ||
            href === `#${cleanKey}` ||
            href.endsWith(`#${cleanKey}`)
        );
    }

    scrollToElement() {
        const elementRect = this.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        // Get header height from CSS variable
        const headerHeight = this.getHeaderHeight();
        const targetPosition = elementRect.top + scrollTop - this.offset - headerHeight;

        window.scrollTo({
            top: targetPosition,
            behavior: this.behavior
        });
    }

    getHeaderHeight() {
        // Get --header-end CSS variable value
        const rootStyles = getComputedStyle(document.documentElement);
        const headerEnd = rootStyles.getPropertyValue('--header-end').trim();

        if (headerEnd) {
            // Parse the value (could be in px, rem, etc.)
            const numericValue = parseFloat(headerEnd);
            if (!isNaN(numericValue)) {
                // If it's in rem, convert to px (assuming 16px = 1rem)
                if (headerEnd.includes('rem')) {
                    return numericValue * 16;
                }
                // If it's already in px or just a number
                return numericValue;
            }
        }

        // Fallback: try to get actual header height
        const header = document.querySelector('header') || document.querySelector('.header');
        if (header) {
            return header.offsetHeight;
        }

        // Default fallback
        return 0;
    }

    // Method to manually trigger scroll
    scrollTo() {
        this.scrollToElement();
    }
}

// Register the custom element
if (!customElements.get('auto-scroll-target')) {
    customElements.define('auto-scroll-target', AutoScrollTarget);
}